module.exports = __webpack_public_path__ + "static/img/welcome.0aeb0c35.png";